import { PhotoKey } from "./photos";

export const AIRFRAME_PHOTOS: Record<string, PhotoKey> = {
  apache: "apache",
  blackshark: "blackshark",
  fulcrum: "fulcrum",
  harrier: "harrier",
  hercules: "hercules",
  hind: "hind",
  hip: "hip",
  hornet: "hornet_sunset",
  huey: "huey",
  kiowa_warrior: "kiowa",
  mig21: "mig21",
  mirage_2000: "mirage2000",
  mirage_f1: "miragef1",
  phantom: "phantom",
  strike_eagle: "strike_eagle",
  tomcat: "tomcat",
  viggen: "viggen",
  viper: "viper",
  warthog: "warthog",
};
